export const insertStringInString = (string: string, adding: string, offset: number): string => {
  return [string.slice(0, offset), adding, string.slice(offset)].join('')
}

export const moveCursor = (inputElement: HTMLDivElement, offset: number): void => {
  const range = document.createRange()
  const selection = window.getSelection()

  range.setStart(inputElement.childNodes[0], offset)
  range.collapse(false)

  if (selection) {
    selection.removeAllRanges()
    selection.addRange(range)
  }
}

export const moveCursorToEnd = (inputElement: HTMLDivElement): void => {
  const range = document.createRange()
  const selection = window.getSelection()
  range.selectNodeContents(inputElement)
  range.collapse(false)
  if (selection) {
    selection.removeAllRanges()
    selection.addRange(range)
  }
}

export const getCursorPosition = (): number | undefined => {
  const selection = window.getSelection()
  return selection?.focusOffset
}

export const appendCodeLine = (previousCodeLineEl: HTMLElement, previousCodeLineIndex: string): void => {
  const codeLineEl = document.createElement('div')
  codeLineEl.setAttribute('data-n', String(Number(previousCodeLineIndex) + 1))
  previousCodeLineEl?.after(codeLineEl)
  moveCursorToEnd(codeLineEl)
}

export const updateCodeIndexes = (): void => {
  const codeLineCollection = document.querySelectorAll('code div')

  codeLineCollection.forEach((line, idx) => {
    const lineNumber = idx + 1
    line.setAttribute('data-n', String(lineNumber))
  })
}

export const setCursorNearCode = (inputElement: HTMLDivElement, codeLines: NodeListOf<Element>, position: 'up' | 'down') => {
  const sel = window.getSelection()

  if (sel && sel.rangeCount) {
    const range = sel.getRangeAt(0)

    const parentElement = range.commonAncestorContainer.parentElement

    if (!parentElement) return

    const isCursorInCode = parentElement.tagName === 'CODE' || parentElement.getAttribute('data-n')

    const codeLineIndex: string | null = parentElement.getAttribute('data-n')

    const isLastCodeLine: boolean = codeLines.length === Number(codeLineIndex)

    if (isLastCodeLine && isCursorInCode) {
      if (position === 'down') {
        const needAddNewLine = inputElement.innerHTML.slice(-7) === '</code>'

        if (needAddNewLine) {
          inputElement.innerHTML = inputElement.innerHTML + '\n'
        }
      }
      else {
        const needAddNewLine = inputElement.innerHTML.slice(0, 6) === '<code>'

        if (needAddNewLine) {
          inputElement.innerHTML = '\n' + inputElement.innerHTML
        }
      }
    }
  }
}